import { Location } from '@angular/common';
import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { SideMenuService } from 'src/app/services/side-menu.service';
import { AppService } from 'src/app/app.service';
import { StorageService } from 'src/app/services/storage.service';
import { NotificationsService } from 'src/app/modules/notifications/notifications-service';
import { CartService } from 'src/app/services/cart.service';
import { Storage } from '@ionic/storage';
import { AppDataService } from 'src/app/services/app-data.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Subscription } from 'rxjs';
import { ModalController, Platform } from '@ionic/angular';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() title: any;
  @Input() showButton: any;
  @Input() routeInfo: any;
  @Input() isLoginPage: boolean;
  @Input() modalID: string;
  isUnreadNotificationAvailable;

  logoUrl: string | undefined = undefined;
  cartItems: any = [];
  cartTotalProductsQty = 0;
  path = '';
  backButtonText: string;
  userData: any = null;
  subscribe: Subscription;
  subscription: Subscription;
  constructor(
    private router: Router,
    public menuService: SideMenuService,
    private appService: AppService,
    private storageService: StorageService,
    private location: Location,
    private notificationsService: NotificationsService,
    private cartService: CartService,
    private platform: Platform,
    private storage: Storage,
    private appDataService: AppDataService,
    private authService: AuthenticationService,
    private modalCtrl: ModalController,
  ) {
    if (this.platform.is('ios')) {
      this.backButtonText = ' ';
      // console.log(this.backButtonText)
    } else {
      this.backButtonText = null;
    }
    this.storage.get('userData').then(userData => {
      if (typeof userData != "undefined" && userData) {
        this.userData = userData;
      }
    });
    if (window.location.pathname.includes("notifications")) {
      this.subscribe = this.router.events.subscribe(async ev => {
        this.isUnreadNotificationAvailable = await this.storageService.getFromLocalStorage(
          'IsBadge'
        );
      })
    }
    this.subscription = this.notificationsService.NotificationBadge.subscribe(async data => {
      if (data) {
        this.isUnreadNotificationAvailable = await this.storageService.getFromLocalStorage('IsBadge');
      }
    })
  }


  async ngOnInit() {
    // console.log(this.showButton)
    this.isUnreadNotificationAvailable = await this.storageService.getFromLocalStorage('IsBadge');
    this.appService.logoUrl.subscribe(url => {
      this.logoUrl = url;
    });
    this.notificationsService.initializeData('Notifications');
    if (this.canShowCart()) {
      // this.title = this.title && (this.title).length > 14 ? (this.title).substring(0, 14) : this.title;
    }
    this.cartService.cart.subscribe(val => {
      this.path = window.location.pathname;
      // console.log('window.location.pathname', window.location.pathname);
      this.cartItems = val.items ?? [];
      this.cartTotalProductsQty = this.cartItems.length ? this.cartItems.map(i => parseInt(i.qty)).reduce((total, num) => parseInt(total) + parseInt(num)) : 0;
      // console.log('this.cartTotalProductsQty', this.cartTotalProductsQty);
    });
  }
  async closeModal() {
    const isModalOpened = await this.modalCtrl.getTop();
    if (!isModalOpened) { return }
    this.modalCtrl.dismiss(null, null, this.modalID)
  }

  async openNotificationPage() {
    const home_menu: any = await this.appDataService.getData('slideout_menu', null, '*', null, { 'is_home_page': 1 })
    if (home_menu && home_menu.data.length) {
      var noti = home_menu.data.filter(i =>
        i.path.split('/')[0] == 'notifications'
      )
      // console.log(noti)
      if (noti && noti.length > 0) {
        this.navigate(noti[0])
      }
    } else {
      this.menuService.selectedIndex = this.menuService.appPages
        .getValue()
        .findIndex((sMenu) => sMenu.uid === 'Notifications');
      this.router.navigate(['notifications/Notifications'], { replaceUrl: true });
    }
  }

  navigate(item) {
    // console.log(item.require_role, this.menuService.currentLoggedInUserRole)
    if (item.www_url) {
      window.open(item.www_url, '_blank')
    } else {
      if (item.url && !item.require_login) {
        this.router.navigate(['notifications/Notifications'], { replaceUrl: true });
      } else if (item.require_login) {
        if (this.authService.isLoggedIn && (item.require_role == this.menuService.currentLoggedInUserRole || this.menuService.currentLoggedInUserRole == 'Administrator' || !item.require_role)) {
          this.router.navigate(['notifications/Notifications'], { replaceUrl: true });
        } else {
          this.router.navigate(['login']);
        }
      } else {
      }
    }
  }

  canShowCart() {
    // return (window.location.pathname).indexOf('eshop/EShop') !== -1 ? true : false;    
    return (this.userData && this.cartItems.length) ? true : false;
  }
  openCartPage() {
    this.menuService.selectedIndex = this.menuService.appPages
      .getValue()
      .findIndex((sMenu) => sMenu.uid === 'cart');
    this.router.navigate(['eshop/EShop/cart'], { replaceUrl: true });
  }

  canShow() {
    if (this.isLoginPage) {
      return false;
    }
    const notificationIconValue = this.appService.systemSettings.notification_icon;

    if (notificationIconValue === 'always') {
      return true;
    } else if (notificationIconValue === 'only-if-unread') {
      return this.isUnreadNotification();
    } else {
      return false;
    }
  }

  isUnreadNotification() {
    return this.isUnreadNotificationAvailable > 0 ? true : false;
  }
  ngOnDestroy() {
    if (this.subscribe) {
      this.subscribe.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
